import React from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-switch-lang';
import { YourName } from '../../../constant';
// eslint-disable-next-line import/no-named-as-default,import/no-named-as-default-member
import authStorage from '../../../storages/mobx/authStorage';

function LoginField({ t }) {
  return (
    <div className="form-group">
      <label className="col-form-label pt-0">{t('auth.YourName')}</label>
      <input
        className="form-control"
        type="email"
        name="email"
        value={authStorage.enteredLogin}
        onChange={(e) => authStorage.changeField('enteredLogin', e.target.value)}
        placeholder={t('auth.Email address')}
      />
    </div>
  );
}

LoginField.propTypes = {};

export default translate(observer(LoginField));
